<template>
  <div id="app">
    <Loading :isProcessing="isProcessing"></Loading>
    <router-view></router-view>
  </div>
</template>

<script>
import Loading from '@/components/parts/common/Loading.vue';

export default {
  name: 'App',
  components: {
    Loading
  },
  computed: {
    isProcessing() {
      return this.$store.getters['alert/isProcessing'];
    }
  },
  updated: function() {
    let message = this.$store.getters['alert/getMessage'];
    if (message) {
      this.$toast.info(message);
    }
    this.$store.dispatch('alert/setMessage', '');
  }
};
</script>
